import { Component, ChangeDetectionStrategy } from '@angular/core';
import { Observable } from 'rxjs';

import { AnnouncementsService } from '@shared/services/announcements.service';

@Component({
  selector: 'app-announcement-badge',
  templateUrl: './announcement-badge.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class AnnouncementBadgeComponent {
  public unreadCount$: Observable<number>;

  constructor(private readonly _announcements: AnnouncementsService) {
    this.unreadCount$ = this._announcements.unreadCount$;
  }

  public toggle(): void {
    this._announcements.toggleSidebar();
  }
}
